import { Col, Row } from 'antd';
import FeatureCard from '../panels/FeatureCard';
const GridView = ({
  contentData
}) => <Row gutter={16} data-sentry-element="Row" data-sentry-component="GridView" data-sentry-source-file="GridView.jsx">
  {contentData.map(datum => datum.type === 'group' ? <div key={datum.key}>
        <h3>{datum.name}</h3>
        <GridView contentData={datum.children} />
      </div> : <Col key={datum.key}>
        <FeatureCard title={datum.name} size='large' image={<img src={datum.imageURL} alt={datum.name} />} url={{
      pathname: `/toolkits/${datum.type}/[slug]`,
      query: {
        slug: datum.slug
      }
    }} />
      </Col>)}
  </Row>;
export default GridView;